<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create Job Band/Grade
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Job Band/Grade"
      text="Create Job Band/Grade"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="value"
                v-validate="'min_value:0|max_value:255|required'"   
                :error-messages="errors.collect('value')"     
                type="number"           
                data-vv-name="value"     
                outlined     
                label="Value"
                :min="0"
                @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>
            <!-- <v-col cols="12">
              <helper-image-input  
                v-model="image" 
                v-validate="'required'"
                :max-size-in-mb="10"
                data-vv-name="image"
                field-name="image"
                accept-type=".svg"
                extension="ext:svg"
              >          
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add Image
                  </v-btn>
                  <span> 
                    {{ image ? image.imageFile.name : 'No file chosen (.svg only)' }}
                  </span>
                </div>
              </helper-image-input>
              <span class="red--text text--lighten-1">{{ errors.first('image') }}</span>
            </v-col> -->
          </v-row>
        </v-container>
      </form> 
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        value: 0,
        image: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return 

        this.resetForm()
      },
    },
    methods: { 
      prepareFormData () {
        if (this.image) {
          this.image.formData.set('value', this.value)
  
          return this.image.formData
        }

        let formData = new FormData()

        formData.append('value', this.value)

        return formData
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.jobBands().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new job band/grade' })

                  this.dialog = false               
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },

      resetForm () {
        this.title = ''
        this.value = 0
        this.image = null

        this.$validator.reset()
      },
    },
  }
</script>
